<template>
  <div class="h5-wrap main">
    <img class="detail-title" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_title.png" alt="">
    <img style="width: .98rem;margin-bottom: .35rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_yitiji.png" alt="">
    <img style="width: 1.03rem;margin-bottom: .2rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_sidagongneng.png" alt="">
    <div class="col-wrap">
      <div class="col-2" style="margin-right:.05rem">红外测温</div>
      <div class="col-2">人脸识别</div>
      <div class="col-2" style="margin-right:.05rem">身份证门禁卡验证</div>
      <div class="col-2">云平台管理</div>
    </div>
    <img style="width: 1.03rem;margin-bottom: .2rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_sanduanxietong.png" alt="">
    <div class="col-wrap">
      <div class="col-3">设备端</div>
      <div class="col-3" style="margin: 0 .05rem;">移动端</div>
      <div class="col-3">PC端</div>
    </div>
    <img style="width: 1.03rem;margin-bottom: .2rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_chanpinyoushi.png" alt="">
    <div class="common-block">
      <img class="common-block-title" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_fengfuchangjing.png" alt="">
      <p>可满足社区、政府、企业、公共开放空间等不同场合的人员进出、考勤、统计、访客管理等需求，温度采集方式灵活，多端协同提供完整解决方案。</p>
      <img class="common-block-title" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jichengdugao.png" alt="">
      <p>单个面板机集成人脸识别、人体体温筛查、IC卡/身份证读取，内置公安部授权的包含指纹信息居民身份证阅读模块，可读取二代/三代居民身份证。</p>
      <div class="common-block-images">
        <img class="left" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jichengdugao1.png" alt="">
        <div class="right">
          <img style="margin-bottom: .15rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jichengdugao2.png" alt="">
          <img src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jichengdugao3.png" alt="">
        </div>
      </div>
      <img class="common-block-title" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_xuexisuanfa.png" alt="">
      <p>集成AInnoFace算法，人脸识别准确率&gt;99.97%、识别速度&lt;100ms，双目活体防伪功能、防照片、视频等欺骗</p>
      <img style="display:block;width:2.35rem; margin: 0 auto .15rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_xuexisuanfa1.png" alt="">
      <img style="display:block;width:2.35rem; margin: 0 auto .2rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_xuexisuanfa2.png" alt="">
      <img class="common-block-title" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_zidongshaicha.png" alt="">
      <p>自动记录人、时间、地点、温度等重要信息。</p>
      <img class="common-block-title" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_cewenxiaolv.png" alt="">
      <p>非接触红外测温，进口医疗级测温芯片，工作环境温度：-10℃～70℃，响应时间200ms，测温距离≤ 1m测温重复精度≤0.3℃，分辨率0.1℃，满足人体体温初筛需求。</p>
      <img style="display:block;width:1.44rem; margin: 0 auto .2rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_cewenxiaolv2.png" alt="">
      <img class="common-block-title" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_bushulinghuo.png" alt="">
      <p>支持公有云、私有云等不同部署方式</p>
    </div>
    <div class="common-block center">
      <img class="common-block-title" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jiguanjiankong.png" alt="">
      <div class="common-block-images">
        <img class="left" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jiguanjiankong1.png" alt="">
        <div class="right">
          <img style="margin-bottom: .2rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jiguanjiankong2.png" alt="">
          <p>一企一码；<br>扫码填报；<br>采集健康状态；<br>自助上传人脸；<br>查询测温信息</p>
        </div>
      </div>
    </div>
    <div class="common-block center">
      <img class="common-block-title" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_renlianyitiji.png" alt="">
      <div class="common-block-images">
        <img class="left" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jichengdugao1.png" alt="">
        <div class="right">
          <p style="padding-top: .45rem">
            高精度测温;<br>
            体温超限报警；<br>
            人脸识别;<br>
            闸机联动；<br>
            扩展口罩识别;<br>
            数据自动上云;<br>
            智能汇总分析。
          </p>
        </div>
      </div>
    </div>
    <div class="common-block center">
      <img class="common-block-title" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jikongfuzhu.png" alt="">
      <div class="common-block-images" style="width: 2.35rem">
        <div class="left" style="width: 1.28rem">
          <img style="width: 100%;margin-bottom: .1rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jikongfuzhu1.png" alt="">
          <img style="width: 100%" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_jikongfuzhu2.png" alt="">
        </div>
        <div class="right" style="width: .86rem">
          <p style="padding-top: .4rem">
            人员注册管理;<br>
            人员健康管理；<br>
            设备管理；<br>
            测温数据统计;<br>
            智能数据分析；<br>
            疫情动态分析；
          </p>
        </div>
      </div>
    </div>
    <img style="width: 1.03rem;margin-bottom: .2rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/detail_lianxiwomen.png" alt="">
    <div class="footer">
      <p v-for="(item,index) in salesman" :key="index">区域销售联系人: <span>{{item.name}}</span>{{item.phone}}</p>
    </div>
    <!-- <img src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/page2.jpg" alt=""> -->
    <el-button class="button" type="primary" @click="backIndex()">返回首页</el-button>
  </div>
</template>
<script>
export default {
  name: 'IntroduceDetail',
  data() {
    return {
      salesman: []
    }
  },
  created() {
    let sm = localStorage.getItem('salesman');
    this.salesman = sm&&JSON.parse(sm).salesman || []
  },
  methods: {
    backIndex() {
      this.$router.push('/h5/index_introduce')
    }
  }
}
</script>
<style scoped lang="scss">
.main {
  padding: .37rem .23rem;
  background:#000033 url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg.png') no-repeat center top / 100% auto;
  &>img {
    display: block;
    margin: 0 auto;
  }
  h3 {
    margin: 0;
    // font-family: "YouSheBiaoTiHei";
    font-weight: bold;
    font-size: .20rem;
    text-align: center;
    letter-spacing: 0;
  }
  .detail-title {
    width: 100%;
    margin-bottom: .2rem;
  }
  .col-wrap {
    overflow: hidden;
    div{
      float: left;
      margin-bottom: .05rem;
      height: .45rem;
      line-height: .45rem;
      text-align: center;
      font-size: .14rem;
      color: #fff;
      background: #472FA0;
      border-radius: .05rem;
    }
    .col-2 {
      width: calc(50% - .05rem);
    }
    .col-3 {
      width: calc(33.33% - .05rem);
    }
    padding-bottom: .2rem;
  }
  .common-block {
    margin-bottom: .2rem;
    padding: .14rem;
    background: #472FA0;
    border-radius: .1rem;
    &-title {
      height: .25rem;
      margin-bottom: .05rem;
    }
    p {
      margin: 0 0 .15rem;
      font-size: .12rem;
      line-height: .16rem;
      color: #fff;
    }
    &-images {
      width: 2.34rem;
      overflow: hidden;
      margin: 0 auto .25rem;
      .left,.right {
        float: left;
      }
      .left {
        width:1.18rem;
        margin-right: .15rem
      }
      .right {
        width: 1rem;
        img {
          width: 100%;
        }
      }
    }
  }
  .center {
    padding-top: .25rem;
    .common-block-title {
      display: block;
      margin: 0 auto .2rem;
      height: .24rem;
    } 
    .common-block-images {
      width: 2.25rem;
      overflow: hidden;
      margin: 0 auto .2rem;
      .left,.right {
        float: left;
      }
      .left {
        width:1.18rem;
        margin-right: .17rem
      }
      .right {
        width: .9rem;
        img {
          width: 100%;
        }
      }
    }
  }
  .footer {
    font-size: .16rem;
    color: #fff;
    text-align: center;
    p {
      margin: 0 0 .1rem;
    }
    span {
      padding: 0 .1rem 0 .04rem 
    }
  }
  .button {
    margin-top: .3rem;
    width: 100%;
    height: .5rem;
  }
}
</style>